// ---------------------------------------------------------------------------
// Exploration identifiers
//
// The user types only a tag on the wizard's first step; the identifier is
// composed once the substrate and the laser are chosen, on the Summary step
// that creates the exploration:
//
//     <Material>-<Alloy>-<LaserID>-<Tag>-<YYYYMMDD>   e.g. SS-AISI304-IPG2020-V1.0-20260930
//
// Material-Alloy = the leading two dash-separated parts of the substrate's
//                  material name (SS-AISI304-U-F-1mm-RUPP -> SS-AISI304),
// LaserID        = the laser_device_name as stored,
// Tag            = free text typed by the user,
// Date           = the day the exploration is started.
// Laser and material are also stored on the Exploration row as foreign keys;
// the name is only the (unique) human-readable handle.
// ---------------------------------------------------------------------------
import { substrateToken, dateStamp } from "./selectionFlow";

/** Any non-empty tag without leading/trailing whitespace (the same rule as
 *  the selection tag). */
export const EXPLORATION_TAG_PATTERN = /^\S(?:.*\S)?$/;

export const EXPLORATION_ID_TEMPLATE = "<Material>-<Alloy>-<LaserID>-<Tag>-<Date>";

export function composeExplorationName(materialName, laserName, tag, date = new Date()) {
    return `${substrateToken(materialName)}-${laserName}-${tag}-${dateStamp(date)}`;
}

/** The identifier as far as it is known: the name step precedes the laser
 *  and substrate steps, so the parts not chosen yet stay as placeholders. */
export function previewExplorationName(materialName, laserName, tag, date = new Date()) {
    const substrate = materialName ? substrateToken(materialName) : "<Material>-<Alloy>";
    const laser = laserName || "<LaserID>";
    const tagPart = tag || "<Tag>";
    return `${substrate}-${laser}-${tagPart}-${dateStamp(date)}`;
}
